export * from './tooltip.dir';

export { default as tooltip } from './tooltip.dir';
